import { ScreenHeader } from '@/components/layout/ScreenHeader';
import { NotFoundContent } from '@/components/ui/NotFoundContent';

export default function NotFoundScreen() {
  return (
    <>
      <ScreenHeader options={{ title: 'Oops!' }} />
      <NotFoundContent />
    </>
  );
}